import { render, staticRenderFns } from "./Notificacao.vue?vue&type=template&id=73c81986"
import script from "./Notificacao.vue?vue&type=script&lang=js"
export * from "./Notificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports